"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Music = void 0;
var three_1 = require("three");
var CSS3DRenderer_1 = require("three/examples/jsm/renderers/CSS3DRenderer");
var function_1 = require("../util/function");
var widget_1 = require("../util/widget");
var waveform_1 = require("../util/waveform");
var axios = require('axios');
var Music = /** @class */ (function () {
    function Music(base) {
        this.base = base;
        this.offset = 1.7;
        this.pos = new three_1.Vector3(this.offset, 0, 0);
        this.normal = new three_1.Vector3(1, 0, 0);
        this.cNormal = new three_1.Vector3();
        this.cPos = new three_1.Vector3();
        this.m4 = new three_1.Matrix4();
        this.defaultSource = 'https%3A//api.soundcloud.com/tracks/327386009';
        this.playStatus = false;
        this.setElement();
    }
    Music.prototype.setElement = function () {
        this.element = this.base.domBundle.querySelector('#music-player');
        this.object = new CSS3DRenderer_1.CSS3DObject(this.element);
        this.object.position.set(this.offset, 0, 0);
        this.object.rotation.y = Math.PI / 2;
        this.object.scale.set(1 / 160, 1 / 160, 1);
        this.init();
    };
    Music.prototype.bindPlayerUIEvent = function () {
        var _this = this;
        var playButton = this.element.querySelector('#music-player-button');
        var banner = this.element.querySelector('#music-player-img img');
        var title = this.element.querySelector('#music-player-title span');
        var artist = this.element.querySelector('#music-player-artist span');
        var permaLink = this.element.querySelector('#music-player-perma-link');
        var waveform = this.element.querySelector('#music-player-waveform');
        var waveformRect = waveform.getBoundingClientRect();
        var contrastFactor = 5;
        var contrastOffset = 128;
        playButton.addEventListener('pointerdown', function () {
            if (!_this.playStatus) {
                widget_1.widget.play();
            }
            else {
                widget_1.widget.pause();
            }
            _this.playStatus = !_this.playStatus;
        });
        widget_1.widget.on('play', function () {
            playButton.classList.add('music-player__btn--pause');
            _this.playStatus = true;
        });
        widget_1.widget.on('pause', function () {
            if (!_this.waveformInstance)
                return;
            playButton.classList.remove('music-player__btn--pause');
            _this.playStatus = false;
            _this.waveformInstance.pause();
        });
        permaLink.addEventListener('pointerdown', function (e) {
            var href = e.currentTarget.href;
            window.open(href, '_blank');
        });
        widget_1.widget.on('play-progress', function (percent) {
            if (!_this.waveformInstance)
                return;
            _this.waveformInstance.playProgress(percent);
        });
        widget_1.widget.on('load', function (soundObject) {
            var _a;
            var picUrl = '';
            if (!!soundObject.artwork_url) {
                picUrl = soundObject.artwork_url.replace(/(.*)(-large)(\.[a-z0-9]{3}[a-z0-9]?)$/, '$1-t500x500$3');
            }
            else {
                picUrl = './assets/images/not-found.jpg';
            }
            //image
            banner.src = picUrl;
            //title
            title.innerHTML = soundObject === null || soundObject === void 0 ? void 0 : soundObject.title;
            //artist
            artist.innerHTML = ((_a = soundObject === null || soundObject === void 0 ? void 0 : soundObject.publisher_metadata) === null || _a === void 0 ? void 0 : _a.artist) || 'Unknown';
            //soundcloud link
            permaLink.href = soundObject === null || soundObject === void 0 ? void 0 : soundObject.permalink_url;
            //get waveform data and render waveform diagram
            axios({
                url: soundObject.waveform_url
            })
                .then(function (res) {
                waveform.innerHTML = '';
                // some contrast calculation 
                var data = res.data.samples.map(function (val) { return ((val - contrastOffset) / 100) * contrastFactor + contrastOffset / 100; });
                _this.waveformInstance = new waveform_1.Waveform({
                    container: waveform,
                    data: data,
                    width: waveformRect.width,
                    height: waveformRect.height,
                    trackLength: data.length,
                    reflection: 0.3,
                    waveWidth: 2,
                    interpolate: true,
                    fadeOpacity: 0.888,
                    bindResize: false // to make the waveform bind to the resize event of the window!!
                });
                _this.waveformInstance.on(waveform_1.EVENT_CLICK, function (percent) {
                    var porpotion = percent / 100;
                    widget_1.widget.seek(porpotion * (soundObject === null || soundObject === void 0 ? void 0 : soundObject.duration));
                    widget_1.widget.play();
                    _this.waveformInstance.playProgress(percent);
                });
            })
                .catch(function (err) { throw err; });
        });
    };
    Music.prototype.init = function () {
        this.bindPlayerUIEvent();
        widget_1.widget.load(this.defaultSource);
    };
    Music.prototype.update = function () {
        (0, function_1.updateOcclude)(this);
    };
    return Music;
}());
exports.Music = Music;
